"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { userData } from '@/Redux/apis/userData';
import { usePathname } from "next/navigation";
function UserData() {
  const $ = _c(8);
  const dispatch = useDispatch();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Cookies.get("token");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const token = t0;
  const pathname = usePathname();
  let type;
  if (pathname.includes("reps")) {
    type = "reps";
  }
  let t1;
  if ($[1] !== type) {
    t1 = {
      token,
      ...(type ? {
        type
      } : {})
    };
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const data = t1;
  let t2;
  if ($[3] !== data || $[4] !== dispatch) {
    t2 = () => {
      const fetchData = async () => {
        if (token !== undefined) {
          ;
          try {
            await dispatch(userData(data));
          } catch (t3) {
            const error = t3;
            console.error("Error fetching user data:", error);
          }
        }
      };
      if (token !== undefined) {
        fetchData();
      }
    };
    $[3] = data;
    $[4] = dispatch;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== dispatch) {
    t3 = [dispatch, token];
    $[6] = dispatch;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  return null;
}
export default UserData;